module.exports = __webpack_public_path__ + "fc76b27ea66a8e1e59dd23e8b0ff0acf.MP3";